<template>
  <div class="home">
    <BodyMenu />
  </div>
</template>

<script>
// @ is an alias to /src
import BodyMenu from "@/components/BodyMenu.vue";
export default {
  name: "Home",
  components: {
    BodyMenu,
  },
};
</script>
 
